'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002411 from "./presto.-Presto$$anon$11.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00249 from "./presto.-Presto$$anon$9.js";
import * as $j_presto$002etypes$0024$002dCompact$002dPlan$0024 from "./presto.types$-Compact-Plan$.js";
import * as $j_presto$002etypes$0024$002dPlan$002dCode$0024 from "./presto.types$-Plan-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$8() {
  this.bbm = null;
  this.bbe = null;
  this.bbf = false;
  this.bbn = null;
  this.bbo = false;
  this.bbr = null;
  this.bbk = null;
  this.bbl = false;
  this.bbg = null;
  this.bbh = false;
  this.bbi = null;
  this.bbj = false;
  this.bbp = false;
  this.bbq = false;
  this.bbm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bbr = "CompactPlan";
}
export { $c_Lpresto_Presto$$anon$8 as $c_Lpresto_Presto$$anon$8 };
$p = $c_Lpresto_Presto$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$8;
/** @constructor */
function $h_Lpresto_Presto$$anon$8() {
}
export { $h_Lpresto_Presto$$anon$8 as $h_Lpresto_Presto$$anon$8 };
$h_Lpresto_Presto$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bbm;
});
$p.M = (function() {
  if ((!this.bbf)) {
    this.bbe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bbf = true;
  }
  return this.bbe;
});
$p.O = (function() {
  if ((!this.bbo)) {
    this.bbn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bbo = true;
  }
  return this.bbn;
});
$p.E = (function() {
  return this.bbr;
});
$p.t = (function() {
  if ((!this.bbl)) {
    this.bbk = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("features", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bbl = true;
  }
  return this.bbk;
});
$p.N = (function() {
  if ((!this.bbh)) {
    this.bbg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPlan$002dCode$0024.$m_Lpresto_types$PlanCode$().adg(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dPresto$0024$0024anon$00249.$c_Lpresto_Presto$$anon$9())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bbh = true;
  }
  return this.bbg;
});
$p.Q = (function() {
  if ((!this.bbj)) {
    this.bbi = new $j_presto$002e$002dPresto$0024$0024anon$002411.$c_Lpresto_Presto$$anon$11();
    this.bbj = true;
  }
  return this.bbi;
});
$p.v = (function() {
  if ((!this.bbq)) {
    this.bbp = false;
    this.bbq = true;
  }
  return this.bbp;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee74) => ((p) => \u03b4scrutinee74.acV(p)))($j_presto$002etypes$0024$002dCompact$002dPlan$0024.$m_Lpresto_types$CompactPlan$())));
});
var $d_Lpresto_Presto$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$8, "presto.Presto$$anon$8", ({
  Ns: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$8 as $d_Lpresto_Presto$$anon$8 };
//# sourceMappingURL=presto.-Presto$$anon$8.js.map
